import { fg } from '@confluence/feature-gating';

import type { useAttachmentsMacroDataQuery$variables } from './__generated__/useAttachmentsMacroDataQuery.graphql.ts';
import type {
	useAttachmentsPageByTitleQuery$data,
	useAttachmentsPageByTitleQuery$variables,
} from './__generated__/useAttachmentsPageByTitleQuery.graphql.ts';
import type { ParsedPageRef } from './useAttachmentsPageByTitleQuery.ts';

export const buildAttachmentsMacroDataQueryVariables = (
	contentId: string,
): useAttachmentsMacroDataQuery$variables => ({
	contentId,
	first: 500,
	offset: 0,
	includeAttachmentActionContext:
		fg('forge_attachment_action_module_metadata') || fg('forge_attachment_action'),
});

export const buildAttachmentsPageByTitleQueryVariables = (
	target: ParsedPageRef | null,
): useAttachmentsPageByTitleQuery$variables => ({
	rawSpaceKey: target?.rawSpaceKey ?? '',
	rawTitle: target?.rawTitle ?? '',
	splitSpaceKey: target?.splitSpaceKey ?? '',
	splitTitle: target?.splitTitle ?? '',
	hasSplit: target?.hasSplit ?? false,
});

export const resolveAttachmentsPageId = (
	data: useAttachmentsPageByTitleQuery$data | null | undefined,
	target: ParsedPageRef | null,
): string | null => {
	const splitNode = data?.splitContent?.nodes?.[0];
	const rawNode = data?.rawContent?.nodes?.[0];
	if (
		splitNode?.title &&
		target?.splitTitle &&
		splitNode.title.toLowerCase() === target.splitTitle.toLowerCase()
	) {
		return splitNode.id ?? null;
	}
	if (
		rawNode?.title &&
		target?.rawTitle &&
		rawNode.title.toLowerCase() === target.rawTitle.toLowerCase()
	) {
		return rawNode.id ?? null;
	}
	return null;
};
